// extracted by mini-css-extract-plugin
export var col = "TwoColContent-module--col--pXb1s";
export var cols = "TwoColContent-module--cols--RzYTl";
export var root = "TwoColContent-module--root--Iy+tL";